declare const STAGE: string;
declare const ROLLBAR_TOKEN: string;

const rollbarConfig = {
	accessToken: ROLLBAR_TOKEN,
	captureUncaught: false,
	captureUnhandledRejections: false,
	checkIgnore: window['rollbarIgnore'],
	payload: {
		environment: STAGE,
		client: {
			javascript: {
				code_version: '1.0.0',
			},
		},
	},
};
export default rollbarConfig;